import {PermissionLevel} from "../../app/api/model/user";
import {useSessionQuery} from "../../app/api/api";

export interface UsePermission {
    /** Returns true, if there is a logged in user and this user has the requested permission level or higher. */
    hasPermission(permission: PermissionLevel): boolean;

    /** Returns true, if there is a logged in user and this user has the exact requested permission level. */
    hasExactPermission(permission: PermissionLevel): boolean;
}

export const usePermission = (): UsePermission => {
    const {data: session} = useSessionQuery();

    const hasPermission = (permission: PermissionLevel): boolean => {
        if (!session) {
            return false;
        }

        return session.permissionLevel >= permission;
    };

    const hasExactPermission = (permission: PermissionLevel): boolean => {
        if (!session) {
            return false;
        }

        return session.permissionLevel === permission;
    };

    return {
        hasPermission,
        hasExactPermission,
    };
};
